<div class="d-flex flex-column align-items-center pt-5 mc-mx-md-64 mi-sent-dialog">
    <img [src]="getSrcImg()" alt="send dialog response">
    <div class="d-flex flex-column align-items-center">
        <h3 class="text-center"> {{sendDialogText?.boldText}}</h3>
        <span class="text-center">{{getDialogText()}}</span>
    </div>
    <div class="d-flex flex-column align-items-center pt-4">
        <span class="mi-sent" (click)="navigation()" id="mi-declarations-close-sent" tabindex="0" role="button"
            (keyup.enter)="navigation()">{{sendDialogText?.backToHome}}
        </span>
    </div>

</div>